export const ageConfig = {
    babyUnlockPeriod: 2,
    babyUnlockPercentage: 50,
};
